import React from "react";
import { CircularProgress, RaisedButton, TextField } from "material-ui";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import OrderablePanel from "./orderable-panel.jsx";
import ImageDropzone from "./image-dropzone.jsx";

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: this.props.url,
      image: this.props.image,
      uploadingImageField: null
    };

    this.onUrlChange = this.onUrlChange.bind(this);
    this.onImageDrop = this.onImageDrop.bind(this);
  }

  onUrlChange(e) {
    this.setState({ url: e.target.value });
    this.props.onUpdate(this.props.keyval, "url", e.target.value);
  }

  onImageDrop(e) {
    var file = e[0],
      reader = new FileReader();

    reader.onloadend = function () {
      // Since it contains the Data URI, we should remove the prefix and keep only Base64 string
      var b64 = reader.result.replace(/^data:.+;base64,/, "");
      file.base64 = b64;
      this.setState({ image: file });
      this.props.onUpdate(this.props.keyval, "image", file);
    }.bind(this);

    reader.readAsDataURL(file);
  }

  getStyles() {
    return {
      displayadeditor: {
        marginRight: 30,
        marginBottom: 15,
        padding: 20,
        border: "1px solid #ccc",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        maxWidth: 370
      },
      dropzone: {
        width: 200,
        padding: 20,
        border: "1px dashed #ccc",
        cursor: "pointer"
      },
      progress: {
        marginBottom: 50
      }
    };
  }

  render() {
    var styles = this.getStyles();
    return (
      <OrderablePanel
        keyval={this.props.keyval}
        onDelete={this.props.onDelete}
        onShiftPosition={this.props.onShiftPosition}
        canShiftUp={this.props.canShiftUp}
        canShiftDown={this.props.canShiftDown}
      >
        {this.state.uploadingImageField === "display_ad_image" ? (
          <div>
            <CircularProgress style={styles.progress} mode="indeterminate" />
          </div>
        ) : null}
        <div
          style={{
            display:
              this.state.uploadingImageField === "display_ad_image"
                ? "none"
                : "block"
          }}
        >
          {this.props.image ? (
            <img
              src={this.props.image.preview || this.props.image}
              width={242}
            />
          ) : (
            <ImageDropzone
              style={styles.dropzone}
              onDrop={e => this.onImageDrop(e)}
            >
              <div>
                To add a new display ad, drop a file here, or click to select.{" "}
                <div
                  style={{
                    marginTop: "0.5em",
                    fontSize: "0.9em",
                    lineHeight: 1.3
                  }}
                >
                  Recommended: at least 600px wide; wide or square aspect ratio.
                </div>
              </div>
            </ImageDropzone>
          )}
        </div>
        <div>
          <div>
            <TextField
              style={{ width: 350 }}
              value={this.props.url || ""}
              floatingLabelText="Display ad link"
              floatingLabelFixed={true}
              placeholder={`Optional external URL (include "https://")`}
              onChange={e => this.onUrlChange(e)}
            />
          </div>
        </div>
      </OrderablePanel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/partials/display-ad-panel.jsx